import { VueReCaptcha } from 'vue-recaptcha-v3'

// Lazy load reCAPTCHA - only initialize when needed
// This reduces initial JavaScript bundle size and improves TTI
let recaptchaInitialized = false
let recaptchaPromise: Promise<void> | null = null

async function initializeReCaptcha(nuxtApp: any) {
  if (recaptchaInitialized) {
    return Promise.resolve()
  }

  if (recaptchaPromise) {
    return recaptchaPromise
  }

  recaptchaPromise = (async () => {
    const config = useRuntimeConfig()
    const siteKey = config.public.recaptchaSiteKey as string | undefined
    const useEnterprise = config.public.recaptchaEnterprise === true

    if (!siteKey) {
      console.warn('⚠️ reCAPTCHA site key not configured. Captcha will be disabled.')
      console.warn('   Set RECAPTCHA_SITE_KEY environment variable to enable reCAPTCHA.')
      return
    }

    // Initialize reCAPTCHA v3 plugin on client only
    // The library automatically loads the script: https://www.google.com/recaptcha/api.js
    // For Enterprise, you may need to manually load enterprise.js (see note below)
    nuxtApp.vueApp.use(VueReCaptcha, {
      siteKey,
      loaderOptions: {
        autoHideBadge: true,
        useRecaptchaNet: false, // Set to true if you need recaptcha.net (e.g., China)
        renderParameters: {
          hl: 'en'
        }
      }
    })

    recaptchaInitialized = true
    console.log('✅ reCAPTCHA v3 initialized with site key:', siteKey.substring(0, 10) + '...')
    
    if (useEnterprise) {
      console.warn('⚠️ Enterprise mode detected. Make sure your site key is for Enterprise.')
      console.warn('   If token generation fails, you may need Enterprise-specific script loading.')
    }
  })()

  return recaptchaPromise
}

export default defineNuxtPlugin((nuxtApp) => {
  // Export initialization function for lazy loading
  nuxtApp.provide('initReCaptcha', () => initializeReCaptcha(nuxtApp))
  
  // Don't initialize immediately - wait for form interaction
  // This reduces initial page load time and unused JavaScript
})

